import { useAuth } from '@clerk/react'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../../hooks/useAuthStore'

export default function AdminRoute({ children }) {
  const { isSignedIn, isLoaded } = useAuth()
  const { user, isAuthenticated } = useAuthStore()

  // Wait for Clerk to initialise
  if (!isLoaded) {
    return (
      <div
        className="min-vh-100 d-flex align-items-center justify-content-center"
        style={{ background: 'linear-gradient(135deg, #0d6efd 0%, #6610f2 100%)' }}
      >
        <div className="text-center text-white">
          <div className="spinner-border mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Loading…</span>
          </div>
          <p className="mb-0 fw-semibold">Checking permissions…</p>
        </div>
      </div>
    )
  }

  if (!isSignedIn) {
    return <Navigate to="/login" replace />
  }

  // Wait for backend sync to populate the role
  if (isSignedIn && !isAuthenticated) {
    return (
      <div
        className="min-vh-100 d-flex align-items-center justify-content-center"
        style={{ background: 'linear-gradient(135deg, #0d6efd 0%, #6610f2 100%)' }}
      >
        <div className="text-center text-white">
          <div className="spinner-border mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Loading…</span>
          </div>
          <p className="mb-0 fw-semibold">Loading profile…</p>
        </div>
      </div>
    )
  }

  if (user?.role !== 'admin') {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center">
        <div className="text-center">
          <i className="bi bi-shield-x text-danger" style={{ fontSize: '4rem' }}></i>
          <h4 className="fw-bold mt-3 mb-2">Access Denied</h4>
          <p className="text-muted mb-4">Admin access is required to view this page.</p>
          <a href="/dashboard" className="btn btn-primary px-4">
            <i className="bi bi-arrow-left me-2"></i>Back to Dashboard
          </a>
        </div>
      </div>
    )
  }

  return children
}
